function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export var getTaskDetailHeaderStyle = function getTaskDetailHeaderStyle(prefixCls, token) {
  var _$concat;
  return _defineProperty({}, ".".concat(prefixCls), (_$concat = {
    containerType: 'inline-size',
    position: 'relative'
  }, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_$concat, "h4", {
    fontSize: '18px',
    color: '#0D1121',
    fontWeight: 600,
    margin: '0px',
    marginBottom: '12px'
  }), ".title", {
    minWidth: '200px'
  }), ".task-info", _defineProperty({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    gap: '40px',
    paddingBottom: '16px'
  }, ".task-info-item", _defineProperty(_defineProperty({}, ".task-info-item-key", {
    textAlign: 'left',
    fontSize: '13px',
    color: '#6E707A',
    marginBottom: '5px',
    minWidth: '80px'
  }), ".task-info-item-value", _defineProperty({
    paddingLeft: '0px',
    fontSize: '14px',
    color: '#0D1121'
  }, ".green-dot", {
    display: 'inline-block',
    width: '8px',
    height: '8px',
    borderRadius: '50%',
    backgroundColor: '#13C2C2',
    marginRight: '5px'
  })))), ".textWarn", {
    color: '#F77234',
    fontSize: '14px',
    fontWeight: 400
  }), ".textDanger", {
    color: '#f5222d',
    fontSize: '14px',
    fontWeight: 400
  }), ".singleLine", {
    flex: 1,
    whiteSpace: 'nowrap'
    // overflow: 'hidden',
    // maxWidth: '400px',
    // textOverflow: 'ellipsis',
  }), ".rightText", {
    alignItems: 'center',
    marginLeft: '6px',
    flexShrink: 0,
    fontSize: '14px'
  }), ".line", {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
    lineHeight: '20px',
    color: '#336DFF !important',
    cursor: 'pointer'
  }), '.task-info-person', {
    minWidth: 0
  }), '.task-info-person-list', {
    flex: 1,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '300px'
  }), _defineProperty(_defineProperty(_$concat, '.flowStatus', {
    position: 'absolute',
    top: '-16px',
    // 这里需要减去当前容器的padding，才能顶到最上面
    right: '0px',
    zIndex: 999
  }), '@container (max-width: 512px)', _defineProperty({}, ".flowStatus", {
    display: 'none'
  }))));
};